module.exports = __webpack_public_path__ + "static/fipcsafari2-d1be625aab51de42e92712c1d3824ec1.jpeg";